export var convertModelToFormData = function (data, form, namespace) {
    if (form === void 0) { form = new FormData(); }
    if (namespace === void 0) { namespace = ''; }
    var formData = form || new FormData();
    var _loop_1 = function (propertyName) {
        if (!data.hasOwnProperty(propertyName) || data[propertyName] == null) {
            return "continue";
        }
        var formKey = namespace ? "".concat(namespace, ".").concat(propertyName) : propertyName;
        var value = data[propertyName];
        if (value instanceof File) {
            // Handle single File object
            formData.append(formKey, value);
        }
        else if (value instanceof Array) {
            if (value.every(function (x) { return x instanceof File; })) {
                // Handle array of File objects
                value.forEach(function (element, index) {
                    formData.append("".concat(formKey, "[").concat(index, "]"), element);
                });
            }
            else if (value.every(function (x) { return typeof x === 'object' && x.file instanceof File; })) {
                // Handle array of objects with 'file' property (e.g., MachineDocumentsList)
                value.forEach(function (element, index) {
                    var tempFormKey = "".concat(formKey, "[").concat(index, "]");
                    // Iterate through all properties of the element
                    for (var prop in element) {
                        if (!element.hasOwnProperty(prop) || element[prop] == null) {
                            continue;
                        }
                        if (prop === 'file' && element[prop] instanceof File) {
                            // Handle the File property
                            formData.append("".concat(tempFormKey, ".File"), element[prop]);
                        }
                        else if (typeof element[prop] === 'boolean') {
                            // Handle boolean properties with PascalCase conversion
                            var pascalCaseProp = prop.charAt(0).toUpperCase() + prop.slice(1);
                            formData.append("".concat(tempFormKey, ".").concat(pascalCaseProp), element[prop].toString());
                        }
                        else if (typeof element[prop] !== 'object') {
                            // Handle other scalar properties (strings, numbers, etc.)
                            var pascalCaseProp = prop.charAt(0).toUpperCase() + prop.slice(1);
                            formData.append("".concat(tempFormKey, ".").concat(pascalCaseProp), element[prop].toString());
                        }
                    }
                });
            }
            else {
                // Handle other arrays (e.g., strings, numbers, or nested objects)
                value.forEach(function (element, index) {
                    var tempFormKey = "".concat(formKey, "[").concat(index, "]");
                    if (typeof element === 'object' && !(element instanceof File)) {
                        convertModelToFormData(element, formData, tempFormKey);
                    }
                    else {
                        formData.append(tempFormKey, element.toString());
                    }
                });
            }
        }
        else if (value instanceof Date) {
            // Handle Date objects
            formData.append(formKey, value.toISOString());
        }
        else if (typeof value === 'object' && !(value instanceof File)) {
            // Handle nested objects
            convertModelToFormData(value, formData, formKey);
        }
        else {
            // Handle scalar values (strings, numbers, booleans)
            formData.append(formKey, value.toString());
        }
    };
    for (var propertyName in data) {
        _loop_1(propertyName);
    }
    return formData;
};
